<template>
	<app-section :class="$attrs.class">
		<div class="flex items-center">
			<app-title title="Customer" class="flex flex-1" />
		</div>
		<app-line />
		<span class="text-info">({{ customer.phonePrefix }}) {{ customer.phone }}</span>
		<div v-if="customer.ordersNr">
			<app-line />
			<div>{{ customer.ordersNr }} orders</div>
		</div>
	</app-section>
</template>

<script>
	import RouteNames from '@/router/names';
	import AppTitle from '@/components/app/AppTitle';
	import CustomerService from '@/services/CustomerService';

	export default {
		name: 'CustomerDetails',
		components: { AppTitle },
		props: {
			customer: {
				required: true,
				type: Object,
			},
		},
		data: () => ({
			RouteNames,
		}),
		methods: {
			blockCustomer() {
				CustomerService.block(this.customer.phone).then(
					() => {
						this.$notificationService.success('Customer blocked successfully');
					},
					(error) => {
						this.$notificationService.error(error);
					}
				);
			},
			canBlockCustomer() {
				return CustomerService.canBlockCustomer();
			},
		},
	};
</script>
